export interface ProductoTerminadoObjOdDTO{
    iddecinvproductoterminadoobjods: number,
	iddecinvproyectoprodtermin: number,
	iddecinvtipoproductoesperado: number,
	iddecinvobjods: number,
	ultimoCambio: string
}

export function getVoidProductoTerminadoObjOdDTO(): ProductoTerminadoObjOdDTO{
    return{
        iddecinvproductoterminadoobjods: 0,
	    iddecinvproyectoprodtermin: 0,
	    iddecinvtipoproductoesperado: 0,
	    iddecinvobjods: 0,
        ultimoCambio: ""
    }
}

export function setProductoTerminadoObjOdDTO(data: any): ProductoTerminadoObjOdDTO{
    return{ 
        iddecinvproductoterminadoobjods: data.iddecinvproductoterminadoobjods??0,
	    iddecinvproyectoprodtermin: data.iddecinvproyectoprodtermin??0,
	    iddecinvtipoproductoesperado: data.iddecinvtipoproductoesperado??0,
	    iddecinvobjods: data.iddecinvobjods??0,
        ultimoCambio: data.ultimoCambio?? "", 
    }
}